// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3g1cj","description":"PatientConsentPreview_description__16NL1"};